import { Truthy } from 'lodash';

import { graphql } from '@/__generated__';
import { useCacheMonitor } from '@/context/DiscoveryUrqlProvider';
import { useQueryStable } from '../useQueryStable';

export type AllSourcesResponse = Truthy<
  ReturnType<typeof useDiscoveryAllSources>[0]['data']
>;

export type AllSourceNode = Truthy<
  Truthy<AllSourcesResponse['environment']['applied']>['lineage']
>[0];

export const GetAllSources = graphql(/* GraphQL */ `
  query AllSources($environmentId: BigInt!, $userId: BigInt) {
    environment(id: $environmentId, userId: $userId) {
      dbtProjectName
      applied {
        lastUpdatedAt
        lineage(filter: { types: [Source] }) {
          ... on SourceLineageNode {
            sourceName
            database
            schema
            uniqueId
          }
        }
      }
    }
  }
`);

type LineageByEnvironmentParams = {
  environmentId: number | undefined;
  userId: number | 'loading' | null;
  pause?: boolean;
};

export const useDiscoveryAllSources = ({
  environmentId = 0,
  userId,
  pause,
}: LineageByEnvironmentParams) => {
  const query = useQueryStable({
    query: GetAllSources,
    variables: {
      environmentId,
      userId: userId as number | null,
    },
    pause: pause || !environmentId || userId === 'loading',
  });

  useCacheMonitor({ applied: query[0].data?.environment.applied?.lastUpdatedAt });

  return query;
};
